import { Box } from "@mui/material";

interface NavigationMenuItemsWrapperTabletProps {
  children: React.ReactNode;
}

export function NavigationMenuItemsWrapperTablet(props: NavigationMenuItemsWrapperTabletProps) {
  const { children } = props;

  return (
    <Box
      aria-label="Navigation menu"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: "108px",
        flexShrink: 0,
        gap: 0.5,
        paddingY: 2,
        paddingX: 2,
        overflowY: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        maskImage:
          "linear-gradient(to bottom, transparent, black 16px, black calc(100% - 16px), transparent)",
      }}
    >
      {children}
    </Box>
  );
}
